declare var ENV_EDITOR: string;
const getEnvironment = ():string => {
  return ENV_EDITOR || 'dev'
};

const getLambdaBaseURL = (env) => {
  const isProd = env === 'prod';
  return isProd ?
    'https://ea1zq4qeu8.execute-api.eu-central-1.amazonaws.com/prod' :
    'https://qga7e00gk5.execute-api.eu-central-1.amazonaws.com/test';
};

export const getAppConfig = () => {
  const env = getEnvironment();
  return {
    env,
    lambdaURL: getLambdaBaseURL(env)
  };
};
